import { AdvanceFilter, FirmSearchRequest, PracticeView, TimeEntryActivity, TimeEntryType, TrustTeamMemberView } from '@/shared/modules/typescript-trustapi-client/models';
import moment from 'moment';
import { Options, Vue } from 'vue-class-component';
import { Inject, Prop, Watch } from 'vue-property-decorator';
import FormatDateTimeMixin from '@/shared/mixins/format-datetime';
import { EventEmitter } from 'events';
import store from '@/trust-admin-app/store';
import { AppInsights } from '@/trust-admin-app/appInsights';
import { TrustAPI } from '@/shared/modules/trust-api';

@Options({
	components: {
	},
	mixins: [FormatDateTimeMixin]
})
export default class TimesheetHeader extends Vue {
	private ai = new AppInsights;

	@Inject({ from: 'apiService', default: new TrustAPI() })
	private apiService!: TrustAPI;

	@Prop() 
	private headerTitle!: string;

	private currentDate = moment(new Date);
	private currentDateDisplay = moment(new Date).format('MMMM YYYY');
	private calendarView = '3'; // monthly view by default; 1: day, 2: week, 3: month
	private currentDatePeriodStart = "";
	private currentDatePeriodEnd = "";

	private showAdvFilter = false;

	private investigators: TrustTeamMemberView[] = [];
	private practices: PracticeView[] = [];
	private activityType: TimeEntryType[] = [];
	private supervisors: TrustTeamMemberView[] = [];

	private loadingDataSet = true
	private errorLoadingDataSet = true;

	private filterApplied = false;

	private advanceFilter: AdvanceFilter = {
		trustTeamMemberId: null,
		supervisorId: null,
		timeEntryActivityId: null,
		practiceName: null
	}

	private showHideAdvFilter() {
		if (this.showAdvFilter) {
			this.showAdvFilter = false
		} else {
			this.showAdvFilter = true
		}
	}

	get showAdvFilterButton(): boolean {
		if (this.headerTitle === "Timesheet") {
			return false
		} else {
			return true
		}
	}

	@Watch('calendarView')
	onCalendarViewChanged(): void {
		this.updateDisplay();
	}

	created(): void {
		if (this.headerTitle !== "Timesheet") {
			this.preloadData();
		}
	}

	mounted(): void {
		this.getTimePeriod();
	}

	get eventCtrl(): EventEmitter {
		return store.getters.getEventController;
	}

	private applyFilter(): void {
		this.$emit('applyFilter', this.advanceFilter);
	}

	private preloadData(): void {
		this.loadInvestigators();
		this.loadTimeEntryActivities();
		this.loadPractices();
		this.loadSupervisors();
	}

	private async loadInvestigators(): Promise<void> {
		try {
			this.loadingDataSet = true;
			this.errorLoadingDataSet = false;
			const res = await this.apiService.TrustTeamMemberApi?.apiV2TrustTeamMemberGetTrustTeamMembersPost({});
			this.investigators = res?.data.data as TrustTeamMemberView[];
		} catch (error) {
			this.errorLoadingDataSet = true;
			console.log(error);
		}
	}

	private async loadTimeEntryActivities(): Promise<void> {
		try {
			this.loadingDataSet = true;
			this.errorLoadingDataSet = false;
			const res = await this.apiService.CodeApi?.apiV2CodeGetTimeEntryActivitiesGet();
			this.activityType = res?.data.data as TimeEntryActivity[];
		} catch (error) {
			this.errorLoadingDataSet = true;
			console.log(error);
		}
	}

	private async loadPractices(): Promise<void> {
		const _body: FirmSearchRequest = {
			keyword: ''
		}
		try {
			this.loadingDataSet = true;
			this.errorLoadingDataSet = false;
			const res = await this.apiService.PracticeApi?.apiV2PracticeSearchPracticePost(_body);
			this.practices = res?.data.data as PracticeView[];
		} catch (error) {
			this.errorLoadingDataSet = true;
			console.log(error);
		}
	}

	private async loadSupervisors(): Promise<void> {
		try {
			this.loadingDataSet = true;
			this.errorLoadingDataSet = false;
			const res = await this.apiService.TrustTeamMemberApi?.apiV2TrustTeamMemberGetSupervisorsGet();
			this.supervisors = res?.data.data as TrustTeamMemberView[];
		} catch (error) {
			this.errorLoadingDataSet = true;
			console.log(error);
		}
	}

	private showAddEventModal() {
		this.$emit('addEntry');
	}

	private getTimePeriod(): void {
		switch (this.calendarView) {
			case '1':
				this.currentDatePeriodStart = moment(this.currentDate).startOf('day').format();
				this.currentDatePeriodStart = moment(this.currentDatePeriodStart).utc().format();
				this.currentDatePeriodEnd = moment(this.currentDate).endOf('day').format();
				this.currentDatePeriodEnd = moment(this.currentDatePeriodEnd).utc().format();
				break;
			case '2':
				this.currentDatePeriodStart = moment(this.currentDate).startOf('week').format();
				this.currentDatePeriodStart = moment(this.currentDatePeriodStart).utc().format();
				this.currentDatePeriodEnd = moment(this.currentDate).endOf('week').format();
				this.currentDatePeriodEnd = moment(this.currentDatePeriodEnd).utc().format();
				break;
			case '3':
				this.currentDatePeriodStart = moment(this.currentDate).startOf('month').format();
				this.currentDatePeriodStart = moment(this.currentDatePeriodStart).utc().format();
				this.currentDatePeriodEnd = moment(this.currentDate).endOf('month').format();
				this.currentDatePeriodEnd = moment(this.currentDatePeriodEnd).utc().format();
				break;
		}

		this.$emit('getTimePeriod', {
			startDatePeriod: this.currentDatePeriodStart,
			endDatePeriod: this.currentDatePeriodEnd
		})
	}

	private prev() {
		switch (this.calendarView) {
			case '1':
				this.currentDate = moment(this.currentDate).subtract(1, 'day');
				break;
			case '2':
				this.currentDate = moment(this.currentDate).subtract(1, 'week');
				break;
			case '3':
				this.currentDate = moment(this.currentDate).subtract(1, 'months');
				break;
		}
		this.$emit('prev', this.currentDate);
		this.updateDisplay();
	}

	private next() {
		switch (this.calendarView) {
			case '1':
				this.currentDate = moment(this.currentDate).add(1, 'day');
				break;
			case '2':
				this.currentDate = moment(this.currentDate).add(1, 'week');
				break;
			case '3':
				this.currentDate = moment(this.currentDate).add(1, 'months');
				break;
		}
		this.$emit('next', this.currentDate);
		this.updateDisplay();
	}

	private today() {
		this.calendarView = '1';
		this.currentDate = moment(new Date());
		this.$emit('today', {
			calendarView: this.calendarView,
			currentDate: this.currentDate
		})
		this.updateDisplay();
	}

	private updateDisplay() {
		const _from_date = moment(this.currentDate).startOf('week');
		const _to_date = moment(this.currentDate).endOf('week');
		switch (this.calendarView) {
			case '1':
				this.currentDateDisplay = moment(this.currentDate).format('dddd, DD MMM YYYY');
				break;
			case '2':
				this.currentDateDisplay = _from_date.format('DD MMM') + ' - ' + _to_date.format('DD MMM YYYY');
				break;
			case '3':
				this.currentDateDisplay = moment(this.currentDate).format('MMMM YYYY');
				break;
		}
		this.$emit('update', this.currentDateDisplay);
		this.getTimePeriod()
	}
}
